export default function Registraction() {
  return (
    <div>
      <h1>Registration</h1>
    </div>
  );
}
